import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { monoColumn, mutedColumn, nameColumn } from 'library/components/DataTable/cells';
import ListScreen, { listPager } from 'library/components/ListScreen';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
var Balances = function (props) {
    var _a, _b, _c, _d;
    var t = props.translate;
    var balanceService = services.balanceService;
    var _e = useState(1), pageNumber = _e[0], setPageNumber = _e[1];
    var _f = useState(''), searchValue = _f[0], setSearchValue = _f[1];
    var debounceRef = useRef(undefined);
    var _g = balanceService.useBalances(pageNumber), data = _g.data, isLoading = _g.isLoading;
    var balances = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        var rows = (data === null || data === void 0 ? void 0 : data.balances) || [];
        if (!query)
            return rows;
        return rows.filter(function (balance) {
            var _a, _b;
            var haystack = [
                balance.getPartnerName(),
                (_a = balance.getAccount()) === null || _a === void 0 ? void 0 : _a.getName(),
                (_b = balance.getFinancialPeriod()) === null || _b === void 0 ? void 0 : _b.getFormattedFromDate(),
                String(balance.getId())
            ].join(' ').toLowerCase();
            return haystack.includes(query);
        });
    }, [data === null || data === void 0 ? void 0 : data.balances, searchValue]);
    var total = Number(((_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.count) || 0);
    var from = Number(((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.from) || 0);
    var to = Number(((_c = data === null || data === void 0 ? void 0 : data.meta) === null || _c === void 0 ? void 0 : _c.to) || 0);
    var pages = Math.max(1, Number(((_d = data === null || data === void 0 ? void 0 : data.meta) === null || _d === void 0 ? void 0 : _d.pages) || 1));
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () { return setSearchValue(value); }, 300);
    };
    var columns = useMemo(function () { return [
        monoColumn({ key: 'id', title: t('id'), width: '72px', value: function (balance) { return balance.getId(); } }),
        nameColumn({ key: 'partner', title: t('partnerName'), width: 'minmax(160px, 1.2fr)', value: function (balance) { return balance.getPartnerName(); } }),
        mutedColumn({ key: 'account', title: t('accountName'), width: 'minmax(160px, 1.2fr)', value: function (balance) { var _a; return (_a = balance.getAccount()) === null || _a === void 0 ? void 0 : _a.getName(); } }),
        monoColumn({ key: 'opening', title: t('openingAmount'), width: '140px', align: 'end', value: function (balance) { return balance.getOpeningAmount(); } }),
        monoColumn({ key: 'amount', title: t('amount'), width: '140px', align: 'end', variant: 'strong', value: function (balance) { return balance.getAmount(); } }),
        monoColumn({ key: 'ending', title: t('endingAmount'), width: '140px', align: 'end', value: function (balance) { return balance.getEndingAmount(); } }),
        mutedColumn({ key: 'period', title: t('financialPeriodStartAt'), width: 'minmax(170px, 1fr)', value: function (balance) { var _a; return (_a = balance.getFinancialPeriod()) === null || _a === void 0 ? void 0 : _a.getFormattedFromDate(); } })
    ]; }, [t]);
    return (_jsx(ListScreen, { title: t('header.balances'), count: t('countBadge', { count: total }), subtitle: t('subtitle'), search: { placeholder: t('searchPlaceholder'), onChange: onSearchValueChange }, children: _jsx(DataTable, { compact: true, minWidth: "1040px", loading: isLoading, rows: balances, rowKey: function (balance) { return balance.getId(); }, empty: _jsx(EmptyComponent, { description: t('empty') }), columns: columns, pager: listPager({
                total: total,
                page: pageNumber,
                pages: pages,
                meta: t('showingRange', { from: from, to: to, total: total }),
                previous: t('previous'),
                next: t('next'),
                center: t('pageOf', { page: pageNumber, pages: pages }),
                setPage: setPageNumber
            }) }) }));
};
export default localeTranslator(Balances, 'balances');
